import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import GenericGrid from 'shared/components/genericGrid/GenericGrid';
import columns from './InvoicesLinesColumns';
import InvoiceStatusSelector from '../../invoiceStatusSelector/InvoiceStatusSelector';
import { neutralWhite, purple } from 's1-ui/themes/sovos-colors';
import SovosIconButton from 's1-ui/sovos-icon-button/SovosIconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import SovosIconMenu from 's1-ui/sovos-icon-menu/SovosIconMenu';
import locationIcon from 'shared/assets/locationicon.png';
import SovosSlidingPanel from 's1-ui/sovos-sliding-panel/SovosSlidingPanel';
import SovosSlidingPanelHeader from 's1-ui/sovos-sliding-panel/components/SovosSlidingPanelHeader';
import InvoiceLineDetail from '../invoiceLinesDetail/InvoiceLinesDetailConnector';
import { withStyles } from '@material-ui/core/es/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Flag from '@material-ui/icons/Flag';
import INVOICE_STATUSES from '../../invoiceStatusSelector/InvoiceStatuses';
import ContextualGridMenuOptions from 'shared/contextualGridMenuOptions/ContextualGridMenuOptions';
import InvoiceDialog from '../../../../InvoiceDialog/InvoiceDialog';
import InvoiceLinesFiltersSlidingPanel from './c/invoiceLinesFilters/InvoiceLinesFiltersSlidingPanelConnector';
import { FilterList } from '@material-ui/icons';
import AllocationGridSlidingPanel from './c/allocationGridSlidingPanel/AllocationGridSlidingPanelConnector';

const initialPageSize = 10;

const styles = {
  content: {
    padding: 0
  }
};

const fileName = 'Export_Lines.xlsx';
const ignoredToPosted =
  'Lines must be Open or Flagged before they can be Posted';
const toPosted = 'Lines being moved to Posted will Accrue Tax';
const allToPosted =
  'Lines being moved to Posted will Accrue Tax. Ignored lines cannot be changed to Posted until they are in either Open or Flagged';

const POSTED_STATUS = INVOICE_STATUSES[1];
const FLAGGED_STATUS = INVOICE_STATUSES[2];
const IGNORE_STATUS = INVOICE_STATUSES[3];
const OPEN_STATUS = INVOICE_STATUSES[4];

class InvoiceLinesGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: initialPageSize,
      pageNumber: 0,
      status: 0,
      selectedInvoiceLine: {},
      openInvoicesLinesSlidingPanel: false,
      openLineFiltersSlidingPanel: false,
      selectedInvoices: [],
      openDialog: false,
      openDeleteDialog: false,
      message: '',
      selectedAllocation: { id: 0, name: '' },
      openAllocationSlidingPanel: false,
      fetchingInvoiceLineData: false
    };
  }

  componentDidMount() {
    this.handleFetchData(0, initialPageSize);
    this.props.invoiceLinesFiltersActions.clearAllInvoiceLineFilters();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.closeSlidingPanelFlag && nextProps.closeSlidingPanelFlag) {
      this.props.closeSlidingPanel();
    }
  }

  handleFetchData = (pageNumber, pageSize) => {
    const { invoiceId } = this.props;
    const { status } = this.state;
    this.props.invoicesActions.fetchInvoicesLines(
      invoiceId,
      status,
      pageNumber,
      pageSize
    );
  };

  handlePageChange = (pageNumber, pageSize) => {
    this.setState({ pageNumber, pageSize }, () =>
      this.handleFetchData(pageNumber, pageSize)
    );
  };

  handleStatusChange = status =>
    this.setState({ status, pageNumber: 0 }, () => {
      this.handleFetchData(0, this.state.pageSize);
    });

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  fetchInvoiceLineData = invoiceLineId => {
    this.setState({ fetchingInvoiceLineData: true });
    axios
      .get(`utm/v1/invoice-lines/${invoiceLineId}`)
      .then(invoiceResponse => {
        this.setState({
          fetchingInvoiceLineData: false,
          selectedInvoiceLine: invoiceResponse.data.data
        });
      })
      .catch(err => {
        throw err;
      });
  };

  handleRowClick = rowData => {
    this.props.invoicesActions.resetJurisdictionalBreakdown();
    this.fetchInvoiceLineData(rowData.id);
    this.setState({ openInvoicesLinesSlidingPanel: true });
    if (rowData.calculatedTax !== null) {
      this.props.invoicesActions
        .fetchInvoiceJurisdictionalBreakdown(rowData.id);
    }
  };

  handleCloseInvoicesLines = () => {
    this.setState({ openInvoicesLinesSlidingPanel: false });
    const { pageNumber, pageSize } = this.state;
    this.handleFetchData(pageNumber, pageSize);
  };

  handleRowsSelectedClick = rowsIndexes => {
    this.setState(() => ({
      selectedInvoices: [
        ...this.props.invoicesLines
          .filter((invoice, index) => rowsIndexes.includes(index))
          .map(invoice => invoice.id)
      ]
    }));
  };

  handleDeleteInvoiceLines = invoiceLines => {
    const { pageSize, status } = this.state;
    const { invoice, pageState } = this.props;
    this.props.invoicesActions.deleteInvoiceLines(
      invoiceLines,
      invoice.id,
      status,
      pageState.page,
      pageSize
    );
    this.handleOpenDialog(false);
  };

  handleOpenDialog = flag => this.setState({ openDeleteDialog: flag });

  getValidLines = (selectedInvoices, value) => {
    let lineStatus = '';
    let ignoreFlag = false;
    let validLines = [];
    const invoicesLines = this.props.invoicesLines;

    invoicesLines.forEach(invoiceLine => {
      selectedInvoices.forEach(invoice => {
        if (invoiceLine.id === invoice) {
          lineStatus = invoiceLine.lineStatus;
          if (lineStatus !== 'Ignored' || value !== POSTED_STATUS.value) {
            validLines.push(invoiceLine.id);
          }
          if (lineStatus === 'Ignored') {
            ignoreFlag = true;
          }
        }
      });
    });

    return { validLines, ignoreFlag };
  };

  showErrorDialogs = (
    ignoreFlag,
    validLines,
    value,
    prevStatus,
    invoiceId,
    pageNumber,
    pageSize
  ) => {
    const periodId = this.props.periodId;
    let headerIdList = [];
    headerIdList.push(invoiceId);
    if (
      ignoreFlag &&
      validLines.length === 0 &&
      value === POSTED_STATUS.value
    ) {
      this.setState({ openDialog: true, message: ignoredToPosted });
    } else if (
      !ignoreFlag &&
      validLines.length > 0 &&
      value === POSTED_STATUS.value
    ) {
      this.setState({ openDialog: true, message: toPosted });
      this.props.invoicesActions.changeInvoicesLinesStatus(
        prevStatus,
        validLines,
        headerIdList,
        value,
        pageNumber,
        pageSize,
        periodId
      );
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    } else if (
      ignoreFlag &&
      validLines.length > 0 &&
      value === POSTED_STATUS.value
    ) {
      this.setState({ openDialog: true, message: allToPosted });
      this.props.invoicesActions.changeInvoicesLinesStatus(
        prevStatus,
        validLines,
        headerIdList,
        value,
        pageNumber,
        pageSize,
        periodId
      );
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    } else {
      this.props.invoicesActions.changeInvoicesLinesStatus(
        prevStatus,
        validLines,
        headerIdList,
        value,
        pageNumber,
        pageSize,
        periodId
      );
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    }
  };

  handleChangeLineStatusClick = (selectedInvoices, value) => {
    const linesResponse = this.getValidLines(selectedInvoices, value);
    const { validLines, ignoreFlag } = linesResponse;
    const prevStatus = this.state.status;
    const invoiceId = parseInt(this.props.invoice.id);
    const { pageNumber, pageSize } = this.state;
    this.showErrorDialogs(
      ignoreFlag,
      validLines,
      value,
      prevStatus,
      invoiceId,
      pageNumber,
      pageSize
    );
  };

  handleDownloadLines = (file, periodId, status, invoice) => {
    const allItems = [];
    const fileName = `${file.id}_${file.name}`;
    this.props.invoicesActions.exportLines(
      fileName,
      periodId,
      invoice.id,
      allItems,
      status
    );
  };

  handleDownloadSelectedLines = (
    file,
    periodId,
    selectedInvoices,
    status,
    invoice
  ) => {
    const fileName = `${file.id}_${file.name}`;
    this.props.invoicesActions.exportLines(
      fileName,
      periodId,
      invoice.id,
      selectedInvoices,
      status
    );
  };

  onAllocationSelect = allocation =>
    this.setState({ selectedAllocation: allocation });

  openAllocationSlidingPanelOnClick = () => {
    this.setState({
      openAllocationSlidingPanel: true,
      selectedAllocation: { id: 0, name: '' }
    });
  };

  handleCloseAllocationSlidingPanel = () =>
    this.setState({ openAllocationSlidingPanel: false });

  handleCloseFilterSlidingPanel = () => {
    const { pageNumber, pageSize } = this.state;
    this.setState({ openLineFiltersSlidingPanel: false }, () => {
      this.handleFetchData(pageNumber, pageSize);
    });
  };

  render() {
    const {
      invoicesLines,
      pageState,
      fetchingInvoicesLines,
      invoice,
      classes,
      periodId,
      appliedFiltersFlag,
      applyingAllocationRule,
      invoiceId
    } = this.props;
    const {
      pageSize,
      status,
      openInvoicesLinesSlidingPanel,
      openLineFiltersSlidingPanel,
      selectedInvoiceLine,
      selectedInvoices,
      selectedAllocation,
      openAllocationSlidingPanel,
      fetchingInvoiceLineData
    } = this.state;
    return (
      <React.Fragment>
        <GenericGrid
          data={ invoicesLines }
          columns={ columns }
          pageNumber={ pageState.page }
          initialPageSize={ pageSize }
          totalItems={ pageState.totalEntries }
          onPageChange={ this.handlePageChange }
          loadingData={ fetchingInvoicesLines || applyingAllocationRule }
          onRowClick={ this.handleRowClick }
          onRowSelection={ this.handleRowsSelectedClick }
          toolBarElements={ [
            <InvoiceStatusSelector
              value={ status }
              onStatusChange={ this.handleStatusChange }
              key={ 'status-selector' }
            />,
            <SovosIconButton
              key={ 'filter-menu' }
              TooltipProps={ { title: 'Filters' } }
              onClick={ () =>
                this.setState({ openLineFiltersSlidingPanel: true })
              }
              style={ {
                backgroundColor: appliedFiltersFlag ? purple : neutralWhite,
                borderRadius: 0,
                margin: '10px'
              } }
              color={ appliedFiltersFlag ? neutralWhite : purple }
            >
              <FilterList />
            </SovosIconButton>,
            <ContextualGridMenuOptions
              key={ 'lines-selector' }
              elementId={ selectedInvoiceLine }
              downloadAllDisabled={ false }
              downloadSelectedDisabled={ false }
              selectedItems={ selectedInvoices }
              fontSize={ '13px' }
              onDownloadSelected={ () =>
                this.handleDownloadSelectedLines(
                  { id: periodId, name: fileName },
                  periodId,
                  selectedInvoices,
                  status,
                  invoice
                )
              }
              onDownloadAll={ () =>
                this.handleDownloadLines(
                  { id: periodId, name: fileName },
                  periodId,
                  status,
                  invoice
                )
              }
            />
          ] }
          bulkActionsElements={ [
            <div key={ 'bulk-flag' }>
              <SovosIconMenu
                iconElement={ <Flag /> }
                toolTipText="Update Status"
                style={ { color: 'white' } }
              >
                <MenuItem
                  onClick={ () =>
                    this.handleChangeLineStatusClick(
                      selectedInvoices,
                      POSTED_STATUS.value
                    )
                  }
                >
                  {POSTED_STATUS.primaryText}
                </MenuItem>
                <MenuItem
                  onClick={ () =>
                    this.handleChangeLineStatusClick(
                      selectedInvoices,
                      FLAGGED_STATUS.value
                    )
                  }
                >
                  {FLAGGED_STATUS.primaryText}
                </MenuItem>
                <MenuItem
                  onClick={ () =>
                    this.handleChangeLineStatusClick(
                      selectedInvoices,
                      IGNORE_STATUS.value
                    )
                  }
                >
                  {IGNORE_STATUS.primaryText}
                </MenuItem>
                <MenuItem
                  onClick={ () =>
                    this.handleChangeLineStatusClick(
                      selectedInvoices,
                      OPEN_STATUS.value
                    )
                  }
                >
                  {OPEN_STATUS.primaryText}
                </MenuItem>
              </SovosIconMenu>
            </div>,
            <SovosIconButton
              key={ 'bulk-alocation' }
              TooltipProps={ { title: 'Apply Allocation Rule' } }
              onClick={ () => this.openAllocationSlidingPanelOnClick() }
            >
              <img src={ locationIcon } />
            </SovosIconButton>,
            <SovosIconButton
              key={ 'bulk-delete' }
              TooltipProps={ { title: 'Delete' } }
              onClick={ () => this.handleOpenDialog(true) }
            >
              <DeleteIcon color={ neutralWhite } />
            </SovosIconButton>
          ] }
        />
        <SovosSlidingPanel
          open={ openInvoicesLinesSlidingPanel }
          onClose={ this.handleCloseInvoicesLines }
          baseWidth={ '1230px' }
          classes={ classes }
        >
          <SovosSlidingPanelHeader
            classes={ {
              root: classes.header
            } }
          />
          <InvoiceLineDetail
            onCloseInvoiceLines={ this.handleCloseInvoicesLines }
            onEditInvoiceLine={ () => this.fetchInvoiceLineData(selectedInvoiceLine.id) }
            invoiceLine={ selectedInvoiceLine }
            invoiceDateAndVendor={ invoice }
            fetchingInvoiceLineData={ fetchingInvoiceLineData }
          />
        </SovosSlidingPanel>
        <InvoiceDialog
          open={ this.state.openDeleteDialog }
          message="Are you sure you want to delete these Lines?"
          onClose={ () => this.handleOpenDialog(false) }
          onContinue={ () => this.handleDeleteInvoiceLines(selectedInvoices) }
          cancelButton="CLOSE"
          okButton="CONTINUE"
        />
        <InvoiceDialog
          open={ this.state.openDialog }
          message={ this.state.message }
          onClose={ this.handleCloseDialog }
          cancelButton="CLOSE"
        />
        <InvoiceLinesFiltersSlidingPanel
          title="Filters"
          open={ openLineFiltersSlidingPanel }
          onClose={ this.handleCloseFilterSlidingPanel }
          baseWidth={ '280px' }
        />
        <AllocationGridSlidingPanel
          open={ openAllocationSlidingPanel }
          onClose={ this.handleCloseAllocationSlidingPanel }
          onApplyAllocation={ this.handleApplyAllocationClick }
          selectedAllocation={ selectedAllocation }
          selectedInvoiceId={ invoiceId }
        />
      </React.Fragment>
    );
  }
}

InvoiceLinesGrid.propTypes = {
  invoice: PropTypes.object,
  invoicesLines: PropTypes.array.isRequired,
  fetchingInvoicesLines: PropTypes.bool.isRequired,
  pageState: PropTypes.object.isRequired,
  appliedFiltersFlag: PropTypes.bool,
  periodId: PropTypes.string.isRequired,
  invoicesActions: PropTypes.shape({
    fetchInvoicesLines: PropTypes.func,
    fetchInvoiceJurisdictionalBreakdown: PropTypes.func,
    resetJurisdictionalBreakdown: PropTypes.func,
    deleteInvoiceLines: PropTypes.func,
    changeInvoicesLinesStatus: PropTypes.func,
    exportLines: PropTypes.func
  }).isRequired,
  classes: PropTypes.object.isRequired,
  closeSlidingPanel: PropTypes.func,
  closeSlidingPanelFlag: PropTypes.bool,
  rulesActions: PropTypes.shape({
    fetchAllocationRules: PropTypes.func
  }),
  invoiceLinesFiltersActions: PropTypes.shape({
    clearAllInvoiceLineFilters: PropTypes.func
  }),
  invoiceId: PropTypes.number.isRequired,
  applyingAllocationRule: PropTypes.bool
};

export default withStyles(styles)(InvoiceLinesGrid);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesGrid/InvoiceLinesGrid.js